export function stringIncludesSpace(string: string | undefined): boolean {
  return string ? string.trim().includes(' ') : false;
}

export function stringExistsInArray(string: string, array: string[]): boolean {
  return array.includes(string.trim());
}

export function arrayContentsEqual(
  array1: string[],
  array2: string[]
): boolean {
  return (
    array1.length === array2.length &&
    array1.every((element) => array2.includes(element))
  );
}
